<template>
  <div
    class="player-hand"
    :class="{ dimmed: isDimmed }"
  >
    <transition-group name="fly-in" tag="div" class="cards">
      <img
        v-for="(card, index) in playerHand"
        :key="`player-card-${dealId}-${index}`"
        class="card"
        :class="{
          invalid: isInvalid(card),
          'smaller-card': totalPlayers > 5,
        }"
        :src="getCardImage(card)"
        @click="playCard(card)"
        :style="{
          transitionDelay: `${index * 0.15}s`,
          cursor: canClick ? 'pointer' : 'default',
        }"
      />
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'PlayerHand',
  props: {
    playerHand: Array,
    dealId: Number,
    isDimmed: Boolean,
    canPlay: Boolean,
    userName: String,
    currentPlayer: String,
    isToeped: Boolean,
    tableCards: Array,
    totalPlayers: Number,
  },
  computed: {
    canClick() {
      return this.userName === this.currentPlayer && !this.isToeped && this.canPlay
    },
  },
  methods: {
    getCardImage(card) {
      if (card.value === undefined || card.suit === undefined) {
        return require('@/assets/svg-cards/Card_back_01.svg')
      }

      const valueMap = {
        12: '10',
        11: '9',
        10: '8',
        9: '7',
        8: '6',
        7: '5',
        6: '4',
        5: '3',
        4: '2',
        3: 'ace',
        2: 'king',
        1: 'queen',
        0: 'jack',
      }

      const suitMap = {
        0: 'hearts',
        1: 'diamonds',
        2: 'clubs',
        3: 'spades',
      }

      const cardValue = valueMap[card.value]
      const cardSuit = suitMap[card.suit]

      if (!cardValue || !cardSuit) {
        console.error('Card mapping error:', card)
        return ''
      }

      try {
        return require(`@/assets/svg-cards/${cardValue}_of_${cardSuit}.svg`)
      } catch (error) {
        console.error('Card image not found:', card, error)
        return ''
      }
    },
    isInvalid(card) {
      if (!this.canPlay || this.userName !== this.currentPlayer || this.isToeped) {
        return false
      }
      return this.playerHand.some(
        (c) =>
          c.suit === this.tableCards[0]?.card.suit && c.suit !== card.suit
      )
    },
    playCard(card) {
      this.$emit('playCard', card)
    },
  },
  emits: ['playCard'],
}
</script>

